import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { UserPill } from "src/cases/common/UserPill";
import { OrganizationUser } from "src/clients/taktile-api";
import { Pill } from "src/design-system/Pill";

type AssigneePillProps = {
  assignee: OrganizationUser;
  withChevron?: boolean;
  fullWidth?: boolean;
};

export const CaseAssigneePill: React.FC<AssigneePillProps> = ({
  assignee,
  withChevron,
}) => {
  return (
    <UserPill
      postfixIcon={withChevron ? <Pill.Icon icon={faChevronDown} /> : undefined}
      user={assignee}
      fullWidth
    />
  );
};
